import styled from 'styled-components';

import { Image } from 'components/recent-order-card/styled';
import SecondaryButton from 'components/secondary-button';

export const Wrapper = styled.div`
  height: 100%;
  min-height: minmax(160px, 100%);
  width: 261px;
  display: grid;
  grid-template-columns: 94px 124px;
  margin: 0 auto;
  padding: 16px;
  column-gap: 8px;
  row-gap: 16px;
  grid-template-areas:
    'imageArea detailsArea'
    'buttonArea buttonArea';
  box-shadow: ${Styles.boxShadow};
  background: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  overflow: hidden;
`;

export const AddItemBtn = styled(SecondaryButton)`
  grid-area: buttonArea;
  justify-self: center;
  height: 30px;
  width: 85px;
  padding: 0px;
  align-self: flex-end;
`;

export const ItemName = styled.h3`
  line-height: 1rem;
  font-size: 1rem;
  margin-top: 0px;
  margin-bottom: 4px;
`;

export const Modifier = styled.p`
  line-height: 1rem;
  font-size: 0.875rem;
  margin: 0 auto;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  grid-area: detailsArea;
`;

export const ExclamationIcon = styled.span`
  color: ${Styles.color.white};
  background-color: ${Styles.color.grey.three};
  height: 1rem;
  width: 1rem;
  font-size: 0.7rem;
  line-height: 0.7rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NotAvailableText = styled.div`
  grid-area: buttonArea;
  align-self: flex-end;
  justify-self: center;
  display: flex;
  align-items: center;
  color: ${Styles.color.grey.three};
  align-self: flex-end;
  height: 30px;
  margin-bottom: 16px;
`;

export const UnavailableText = styled.span`
  padding-left: 8px;
  font-size: 1rem;
  line-height: 1rem;
`;

export const ItemImage = styled(Image)`
  grid-area: imageArea;
  & > div {
    margin: 0px;
  }
`;
